const ComponentsLookup = {
  "default-footer": "DefaultFooter4f938dbaF5f1479c84368f84bebbc2c4"
}

export default ComponentsLookup;